import { RadioSelectVariant } from '@kanda-libs/ks-component-ts';
import { YOUR_INFO_CLASS_NAMES } from '../../../constants';

export const PROPS = {
  title: {
    text: 'Personal Information',
    className: YOUR_INFO_CLASS_NAMES.title,
  },
  description: {
    text: 'We need a few more personal details to complete your application',
    className: 'text-style-g text-neutral-700 mb-6 -mt-4',
  },
  gender: {
    label: 'Gender',
    placeholder: 'Select...',
    variant: 'streamline-radio' as RadioSelectVariant,
    inline: true,
    wrap: true,
  },
  maritalStatus: {
    label: 'Marital status',
    placeholder: 'Select...',
  },
  numberOfDependents: {
    label: 'No. of dependents',
    placeholder: 'e.g. 0',
    validation: {
      required: {
        value: true,
        message: 'Number of dependents is required',
      },
      min: {
        value: 0,
        message: 'Number of dependents must be a minimum of 0',
      },
      max: {
        value: 20,
        message: 'Number of dependents must be a maximum of 20',
      },
    },
  },
  phoneNumber: {
    label: 'Landline Phone Number (optional)',
    placeholder: 'Phone number',
    validation: {
      pattern: {
        value: /^(0)?[1,2,3,7,8][0-9]{9}$/,
        message: 'Telephone number is not a valid UK phone number',
      },
    },
  },
};
